import { changeLoginStateAction } from "@3gaam/app/src/store/auth";
import notify from "@3gaam/shared/components/general/notification";
import { b64ToUtf8 } from "@3gaam/shared/utils/base64";
import { localStorageGet } from "@3gaam/shared/utils/localStorage";
import axios from "axios";
import { store } from "./store";

let version = process.env.REACT_APP_VERSION;

const handledErrors = [
  "UnreservedCounselorAppointment",
  "EarlyCounselorAppointment",
  "EmptyReservableCounselorAppointment",
  "UnavailableCounselor",
  "UncallableCounselor",
];

let onAxiosRequest = () => {
  axios.interceptors.request.use(
    (config) => {
      const _consulteeId = localStorageGet("ConsulteeId");
      config.timeout = config.timeout || 20000;
      //@ts-ignore
      config.headers.common.Accept = "application/json";
      //@ts-ignore
      config.headers.common["Content-Type"] = "application/json";
      //@ts-ignore
      config.headers.common["Current-Client-Type"] = "APP";
      //@ts-ignore
      config.headers.common["Current-Client-Version"] = version;
      //@ts-ignore
      config.headers.ConsulteeId = _consulteeId || "";

      const accessToken = store.getState().auth.Token?.AccessToken;

      //@ts-ignore
      accessToken && (config.headers.Authorization = accessToken);

      config.withCredentials = true;
      return config;
    },
    (error) => {
      return Promise.reject(error);
    },
  );
};

let onAxiosResponse = (handleShowUpdateModal) => {
  axios.interceptors.response.use(
    (response) => {
      const versionCommand =
        response.headers["client-version-command"]?.toLowerCase();
      const latestVersion = response.headers["latest-client-version"];
      const clientMessage =
        b64ToUtf8(response.headers["latest-client-message"]) ||
        "نسخه جدید نرم‌افزار منتشر شده";
      const latestLocalVersion = localStorage.getItem("version");
      let upgradeModalShownBefore = !!(
        latestLocalVersion && latestVersion === latestLocalVersion
      );
      if (versionCommand === "upgrade" && !upgradeModalShownBefore) {
        handleShowUpdateModal({
          ignorable: true,
          message: clientMessage,
          latestVersion,
        });
        // prevent to show optional update modal again
        localStorage.setItem("version", latestVersion);
      }
      //@ts-ignore
      if (response.config.url.includes("EssentialsQuery/Essentials")) {
        store.dispatch(changeLoginStateAction(true));
      }

      return response;
    },
    (error) => {
      if (error?.response?.status === 412) {
        let message =
          error?.response?.data?.UpgradeMessage ||
          b64ToUtf8(error?.response?.headers["latest-client-message"]) ||
          "نسخه فعلی نرم‌افزار منقضی شده";
        handleShowUpdateModal({ ignorable: false, message });
        return Promise.reject(false);
      } else if (error?.response?.status === 400) {
        const _error = error?.response?.data;
        if (!handledErrors.includes(_error.Type)) {
          notify({
            type: "danger",
            message: (
              <div>
                <h6>اشکال در ارسال درخواست به سرور.</h6>
                <small>{_error.Type}</small>
              </div>
            ),
          });
        }
        Promise.reject(error?.response);
      } else if (error?.response?.status === 403) {
        Promise.reject(error?.response);
      } else if (error?.response?.status === 401) {
        Promise.reject(error?.response);
      } else if (error?.response?.status === 500) {
        notify({
          type: "danger",
          message: "اشکالی رخ داده است.",
        });
      } else {
        notify({
          type: "warning",
          message: (
            <div>
              <h6>اشکال در برقراری ارتباط با سرور</h6>
              <small>{error.message}</small>
            </div>
          ),
        });
      }
      return Promise.reject(error?.response);
    },
  );
};

export { onAxiosRequest, onAxiosResponse };
